var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.msg && _vm.msg.hasMessage)?_c('o-form-group',[_c('b-input-group',[_c('b-alert',{attrs:{"show":"","variant":_vm.msg.variant,"dismissible":""},on:{"dismissed":function($event){_vm.msg = null}}},[_vm._v(" "+_vm._s(_vm.msg.message)+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }